export function getApp(): 'consumidorpositivo' | 'acordocerto' {
  const domain = import.meta.env.VITE_DOMAIN;

  if (domain?.includes('consumidorpositivo')) {
    return 'consumidorpositivo';
  }

  return 'acordocerto';
}
